// eslint-disable-next-line
(function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode banner closeBanner creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode".split(" "), 0);

const branchData = window.BranchData;
const joinPageData = {
  '$desktop_url': branchData.defaultURL,
  '$android_url': branchData.defaultURL,
  '$windows_phone_url': branchData.defaultURL,
  '$blackberry_url': branchData.defaultURL,
  '$fire_url': branchData.defaultURL,
  ...branchData.data
};

let branchInitizalized = false;
const initBranch = () => {
  if (!branchInitizalized) {
    branchInitizalized = true;
    window.branch.init(branchData.key);  
  }
};

document.querySelectorAll('.text-app-link-form').forEach(function(elem) {
  elem.addEventListener('submit', function(e) {
    initBranch();
    e.preventDefault();

    const mobile = this.mobile.value;

    window.branch.sendSMS(mobile, {
      feature: 'referral-sms',
      tags: branchData.tags,
      data: joinPageData
    }, {}, () => {});

    this.mobile.value = '';
    this.submit.innerHTML = '<i class="rm rm-raise-check"></i>';

    setTimeout(() => {
      this.submit.innerHTML = 'Send';
    }, 4000);
  });
});

if (location.pathname.substring(0, 5) === '/join') {
  initBranch();

  window.branch.link({
    feature: 'app-store-badge',
    tags: branchData.tags,
    data: joinPageData
  }, (err, url) => {
    if (!err) {
      document.querySelector('.app-banner-link').setAttribute('href', url);
    }
  });
  
  window.branch.setBranchViewData({
    feature: 'app-store-banner',
    tags: branchData.tags,
    data: joinPageData
  });
  
}
